import Splide from '@splidejs/splide';

export default class HeroSlider {

    getCarouselOptions(container) {

        new Splide(container, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            autoplay: true,
            interval: 6000,
            speed: 1000,
            arrows: false,
            pagination: true,
            easing: 'linear',
            direction: 'ttb',
            height: '600px',
            breakpoints: {
                // Custom breakpoints can be added here if mobile-first is needed
            },
        }).mount();

    }

    triggerCarousel() {
        const blocks = document.querySelectorAll(".hero-slider");
        if (blocks.length) {
            [...blocks].forEach((block) => {
                    const slider = block.querySelector(".splide");

                    if (slider) {
                        this.getCarouselOptions('.' + slider.getAttribute('class'));
                    }

                }
            );
        }
    }

    init() {
        this.triggerCarousel()
    }
}
